const steps = [
  { n: "01", color: "bg-brutal-yellow", title: "Configure em poucos minutos", desc: "Cadastre seus produtos com foto e preço. Se sabe usar WhatsApp, sabe usar o Pede é Fácil. E se travar, a gente configura com você.", rotate: "lg:-rotate-1" },
  { n: "02", color: "bg-brutal-pink", title: "O cliente pede (ou a IA responde)", desc: "QR code na mesa, link no delivery ou conversando com a IA no WhatsApp. O pedido chega do jeito que o cliente preferir.", rotate: "lg:rotate-1" },
  { n: "03", color: "bg-brutal-lime", title: "Sai na impressora, vai pra cozinha", desc: "A cozinha recebe na hora, o painel atualiza sozinho e o entregador é avisado. Você só acompanha tudo acontecendo.", rotate: "lg:-rotate-1" },
];

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-it-works" className="relative py-24 sm:py-32 bg-brutal-yellow border-y-[3px] border-brutal-black overflow-hidden">
    <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: "repeating-linear-gradient(-45deg, #0A0A0A 0 2px, transparent 2px 22px)" }} />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
      <div className="max-w-2xl">
        <div className="inline-flex items-center gap-2 bg-brutal-black border-[2.5px] border-brutal-black px-3.5 py-1.5">
          <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-brutal-yellow">★ COMO FUNCIONA</span>
        </div>
        <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brutal-black uppercase leading-[0.95]">
          Feito pra quem<br />
          <span className="bg-white border-[3px] border-brutal-black px-3 inline-block shadow-brutal mt-2">nunca mexeu com sistema</span>
        </h2>
      </div>
      <div className="mt-16 grid md:grid-cols-3 gap-7 sm:gap-8">
        {steps.map((s) => (
          <div key={s.n} data-testid={`how-step-${s.n}`} className={`relative bg-white border-[3px] border-brutal-black p-8 shadow-brutal-lg hover:translate-y-[-4px] hover:shadow-brutal-xl transition-all ${s.rotate}`}>
            <div className={`absolute -top-6 -left-3 inline-flex items-center justify-center w-16 h-16 border-[3px] border-brutal-black ${s.color} shadow-brutal-sm`}>
              <span className="font-heading text-2xl text-brutal-black">{s.n}</span>
            </div>
            <div className="mt-6">
              <h3 className="font-heading text-xl text-brutal-black uppercase leading-tight">{s.title}</h3>
              <p className="mt-3 text-brutal-black leading-relaxed text-sm font-medium">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
